import { useContext } from 'react';
import {
  EditorContext,
  ActionCreator as EditorActionCreator,
} from '../../context/EditorProvider';

export const useEditorContext = () => {
  const {
    editorDispatch,
    editorState: {
      generationText,
      generationId,
      generationChatId,
      generationTitle,
      generationSubjectGroup,
      userHomeworkHelpRequest,
      userHomeworkHelpNextRequest,
      userHomeworkHelpSubject,
      userHomeworkHelpTextFromFiles,
    },
  } = useContext(EditorContext);

  return {
    editorDispatch,
    generationText,
    generationId,
    generationChatId,
    generationTitle,
    generationSubjectGroup,
    userHomeworkHelpRequest,
    userHomeworkHelpNextRequest,
    userHomeworkHelpSubject,
    userHomeworkHelpTextFromFiles,
    EditorActionCreator,
  };
};
